export default "__VITE_ASSET__C6owoJZc__"